import { useState, useEffect } from 'react';
import { collection, query, getDocs, where } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { useAuth } from '../../contexts/AuthContext';
import { AlertTriangle } from 'lucide-react';

export default function PricebenchStats() {
  const [totalProducts, setTotalProducts] = useState(0);
  const [pricebenchProducts, setPricebenchProducts] = useState(0);
  const { currentUser } = useAuth();

  useEffect(() => {
    const loadStats = async () => {
      if (!currentUser?.companyId) return;

      try {
        // Carregar total de produtos
        const productsRef = collection(db, 'products');
        const productsQuery = query(
          productsRef,
          where('companyId', '==', currentUser.companyId)
        );
        const productsSnapshot = await getDocs(productsQuery);
        setTotalProducts(productsSnapshot.size);

        // Carregar produtos no pricebench
        const pricebenchRef = collection(db, 'pricebench');
        const pricebenchQuery = query(
          pricebenchRef,
          where('companyId', '==', currentUser.companyId)
        );
        const pricebenchSnapshot = await getDocs(pricebenchQuery);
        setPricebenchProducts(pricebenchSnapshot.size);
      } catch (error) {
        console.error('Erro ao carregar estatísticas:', error);
      }
    };

    loadStats();
  }, [currentUser]);

  const missingProducts = totalProducts - pricebenchProducts;

  return (
    <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <AlertTriangle className="h-6 w-6 text-yellow-500 mr-2" />
          <h3 className="text-lg font-medium text-gray-900">Produtos em Falta</h3>
        </div>
        <span className="text-2xl font-bold text-yellow-500">{missingProducts}</span>
      </div>
      <p className="mt-2 text-sm text-gray-600">
        Produtos que ainda não foram adicionados ao comparador de preços
      </p>
    </div>
  );
}
